"use client"

import { FileDown } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FileDownIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FileDownIcon = component(Icon)({ as: FileDown })
